import { JobTitle } from '@pflegia/data-access';
import { B_PRIORITIES, C_PRIORITIES, CandidatePriority } from '@pflegia/types/api/candidate/candidate-priority';
import { NursingArea } from '@pflegia/types/api/candidate/nursing-area';
import { QualificationRecognition, RecognitionQuestions } from '@pflegia/types/api/candidate/recognition';
import { FunnelQuestion } from '@pflegia/types/api/funnel/questions';
import { JobTitleEnum } from '@pflegia/types/api/job-title/job-titles.enum';
import { RecognitionStatus } from '@pflegia/types/common/candidate/recognition-status';
import { getSelectedJobTitleAndStep } from '@pflegia/ui/funnel/utils/job-titles';
import { FunnelAnswers } from '@pflegia/ui/pflegia/funnel/types/funnel-answers';

/**
 * Determines whether Praxia flow should be used by checking nursing area answer.
 */
export const isMedicalStaffFlow = (answers: FunnelAnswers) => {
  const nursingArea = answers[FunnelQuestion.NursingAreaWorking];
  return nursingArea === NursingArea.MedicalStaff;
};

/**
 * When selecting NotYetApplied, For either B or C Qualifications, DQualification Questions should not be displayed
 */
export const shouldDowngradeQualificationQuestionByRecognition = (answers: FunnelAnswers, question: FunnelQuestion) => {
  if ((answers[`${question}Recognition` as RecognitionQuestions] as QualificationRecognition)?.status !== RecognitionStatus.NotYetApplied)
    return false;
  const jobTitleAnswer = getSelectedJobTitleAndStep<JobTitle>(answers, question);
  if (
    jobTitleAnswer.jobTitle.title === JobTitleEnum.Companion &&
    C_PRIORITIES.includes(jobTitleAnswer.jobTitle.trackingPriority as CandidatePriority)
  ) {
    return false;
  }
  return [...B_PRIORITIES, ...C_PRIORITIES].includes(jobTitleAnswer.jobTitle.trackingPriority as CandidatePriority);
};
